import React, {useEffect, useRef, useState} from "react"
import Styles from "./table.less"
import backImg from "../../static/pic/back.svg"
import forwardImg from "../../static/pic/forward.svg"
import {AttachmentItem, HistoricalDataItem} from "../../reducer/interface/dataInterface"
import {TableColumn} from "../operate/interface"
const Table: React.FunctionComponent<{
    selectItem: AttachmentItem | HistoricalDataItem | null
    dataSource: Array<AttachmentItem> | Array<HistoricalDataItem> | undefined
    column: any
    onSelect: (item: any) => void
}> = ({selectItem, dataSource, column, onSelect}) => {
    const tableArea = useRef<HTMLDivElement>(null)
    const [pageData, setPageData] = useState<any>({total: 0, pageSize: 10, current: 1, pageNum: 1})
    const [display, setDisplay] = useState<any>([])
    useEffect(() => {
        const PageSize =
            tableArea.current?.offsetHeight === 0
                ? pageData.pageSize
                : Math.ceil((tableArea.current?.offsetHeight ? tableArea.current?.offsetHeight : 0) / 41)
        setPageData({
            ...pageData,
            total: dataSource?.length,
            pageSize: PageSize,
            pageNum: Math.ceil((dataSource?.length ? dataSource?.length : 0) / PageSize),
        })
        setDisplay(dataSource?.slice((pageData.current - 1) * PageSize, pageData.current * PageSize))
    }, [dataSource])
    const getRadioStyle = (id: string | number | undefined) => {
        if (id === selectItem?.id) {
            return {
                inner: {
                    backgroundColor: "#5582F3",
                    width: 8,
                    height: 8,
                },
                outer: {
                    border: "1px solid #5582F3",
                },
            }
        }
    }
    const pageTurn = (type: string) => {
        if (type === "back") {
            if (!(pageData.current - 1 <= 0)) {
                setPageData({...pageData, current: pageData.current - 1})
                setDisplay(
                    dataSource?.slice(
                        (pageData.current - 2) * pageData.pageSize,
                        (pageData.current - 1) * pageData.pageSize
                    )
                )
            }
        } else if (type === "forward") {
            if (!(pageData.current + 1 > pageData.pageNum)) {
                setPageData({...pageData, current: pageData.current + 1})
                setDisplay(
                    dataSource?.slice(pageData.current * pageData.pageSize, (pageData.current + 1) * pageData.pageSize)
                )
            }
        }
    }
    const renderDisplay = () => {
        if (display) {
            return display.map((data: any) => {
                return (
                    <div
                        key={`dataSource${data?.id}`}
                        onClick={() => onSelect(data)}
                        className={Styles.dataSourceItemWrapper}
                    >
                        <div className={Styles.radioCol}>
                            <div
                                style={getRadioStyle(data?.id)?.outer}
                                onClick={() => onSelect(data)}
                                className={Styles.selectRadioOuterRing}
                            >
                                <div className={Styles.selectRadioInnerRing} style={getRadioStyle(data?.id)?.inner} />
                            </div>
                        </div>
                        {column
                            .filter((columnItem: TableColumn) => columnItem.isShow === true)
                            .map((item: TableColumn) => {
                                return (
                                    <div key={item.key} style={{...item.style}} className={Styles.tableItemBasic}>
                                        <div className={Styles.tableItemBasicContent}>{item.render(data)}</div>
                                    </div>
                                )
                            })}
                    </div>
                )
            })
        } else {
            return null
        }
    }
    const renderForze = () => {
        if (display) {
            return display.map((data: any) => {
                return (
                    <div
                        key={`dataSource${data?.id}`}
                        onClick={() => onSelect(data)}
                        className={Styles.dataSourceItemWrapper}
                    >
                        {column
                            .filter((columnItem: TableColumn) => columnItem.isShow === true)
                            .map((item: TableColumn) => {
                                return (
                                    <div key={item.key} style={{...item.style}} className={Styles.tableItemBasic}>
                                        <div className={Styles.tableItemBasicContent}>{item.render(data)}</div>
                                    </div>
                                )
                            })}
                    </div>
                )
            })
        } else {
            return null
        }
    }
    return (
        <div className={Styles.tableWrapper}>
            <div className={Styles.tableNav}>
                <span>共{pageData.total}条</span>
                <div className={Styles.PageTurningTool}>
                    <div onClick={() => pageTurn("back")} className={Styles.PageBtn}>
                        <img alt={""} src={backImg} />
                    </div>
                    <div className={Styles.PageTurning}>{pageData.current}</div>
                    <div onClick={() => pageTurn("forward")} className={Styles.PageBtn}>
                        <img alt={""} src={forwardImg} />
                    </div>
                </div>
            </div>
            <div className={Styles.tableBody}>
                <div className={Styles.tableScrollAreaHiddenY}>
                    <div className={Styles.tableScrollArea}>
                        <div className={Styles.columns}>
                            <div className={Styles.radioCol}>
                                <div className={Styles.selectRadioOuterRing} />
                            </div>
                            {column
                                .filter((columnItem: TableColumn) => columnItem.isShow === true)
                                .map((item: TableColumn) => {
                                    return (
                                        <div key={item.key} style={{...item.style}} className={Styles.tableItemTabs}>
                                            {item.title}
                                        </div>
                                    )
                                })}
                        </div>
                        <div ref={tableArea} className={Styles.tableDataArea}>
                            {renderDisplay()}
                        </div>
                    </div>
                </div>
                {/* <div className={Styles.frozeTableCol}>
                    <div className={Styles.columns}>
                        {column
                            .filter((columnItem: TableColumn) => columnItem.isShow === true)
                            .map((item: TableColumn) => {
                                return (
                                    <div key={item.key} style={{...item.style}} className={Styles.tableItemTabs}>
                                        {item.title}
                                    </div>
                                )
                            })}
                    </div>
                    <div ref={tableArea} className={Styles.tableDataArea}>
                        {renderForze()}
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default Table
